import React from 'react'
import Link from 'next/link'
import styled from '@emotion/styled'
import { Product } from 'services/ContentfulService/models/product'
import { COLORS, PAGE_BREAKPOINTS } from 'parameters'
import { ContentfulImage } from 'experiences/shared/ContentfulImage'

interface Props {
	title?: string
	products: Product[]
}

export const ProductsSection: React.FC<React.PropsWithChildren<Props>> = ({ title, products }) => {
	if (products.length === 0) {
		return null
	}
	return (
		<CarouselWrapper>
			{title && <ProductsTitle>{title}</ProductsTitle>}
			<CarouselItems>
				{products
					.filter(p => p.learnHub)
					.map(product => (
						<CarouselItemHolder key={product.id}>
							<Link href={product.relativeLearnPath} prefetch={false} legacyBehavior>
								<CarouselItem>
									<CarouselItemIcon>
										<ContentfulImage asset={product.graphic} />
									</CarouselItemIcon>
									<Link passHref href={product.relativeLearnPath} legacyBehavior>
										<CarouselItemTitle>{product.name}</CarouselItemTitle>
									</Link>
								</CarouselItem>
							</Link>
						</CarouselItemHolder>
					))}
			</CarouselItems>
		</CarouselWrapper>
	)
}

const CarouselWrapper = styled.div``

const ProductsTitle = styled.h2``

const CarouselItemTitle = styled.a`
	font-size: 18px;
	font-weight: bold;
	margin-top: 10px;
	color: #0d0808;
	text-decoration: none;
	:hover {
		color: initial;
	}
`

export const CarouselItems = styled.div`
	display: flex;
	overflow-x: scroll;
	padding: 20px;
	margin: 0 -20px;
	justify-content: space-between;
	-webkit-overflow-scrolling: touch;
	&::-webkit-scrollbar {
		display: none;
	}
`

export const CarouselItem = styled.div`
	width: 190px;
	height: 160px;
	padding: 24px 23px 24px 24px;
	border-radius: 8px;
	box-shadow: 0 0 20px 0 rgba(69, 69, 69, 0.16);
	background-color: ${COLORS.WHITE};
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	text-align: center;
	transition: 0.3s;

	&:last-child {
		margin-right: 0;
	}

	p {
		font-size: 18px;
		font-weight: bold;
		margin-top: 10px;
	}

	&:hover {
		transform: translateY(-5px);
	}

	@media screen and (${PAGE_BREAKPOINTS.MOBILE}) {
		width: 144px;
		height: 144px;
	}
`

const CarouselItemHolder = styled.div`
	padding-right: 30px;

	&:last-of-type {
		padding-right: 0;
	}

	@media screen and (${PAGE_BREAKPOINTS.DESKTOP_LARGE}) {
		&:last-of-type {
			padding-right: 20px;
		}
	}

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		padding-right: 20px;
	}
`

const CarouselItemIcon = styled.div`
	display: flex;
	position: relative;
	align-items: center;
	justify-content: center;

	width: 50px;
	height: 50px;
`
